import { FC } from 'react'

import Flex from '@/shared/ui/Flex'
import { Col } from '@/shared/ui/Grid'
import { Image } from '@/shared/ui/Image'

import styles from './GiftBenefit.module.scss'

type GiftBenefitProps = {
	title: string
	description: string
	imgSrc: string
}

/**
 * Benefit with title, description and icons/images
 * @param props
 * @param props.title - title of benefit
 * @param props.description - description of benefit
 * @param props.imgSrc - image url of benefit
 */
export const GiftBenefit: FC<GiftBenefitProps> = ({ title, description, imgSrc }) => (
	<Col xl={8} xs={24}>
		<article className={styles.wrapper}>
			<Flex justifybetween alignStart>
				<div>
					<h3 className={styles.title}>{title}</h3>
					<p className={styles.description}>{description}</p>
				</div>
				<div className={styles.imageWrap}>
					<Image alt="" src={imgSrc} width={86} height={86} />
				</div>
			</Flex>
		</article>
	</Col>
)
